import { memo, useCallback } from 'react';
import { MenuItem } from 'react-pro-sidebar';

import { useNavigate } from 'react-router-dom';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import { Typography } from '@mui/material';
import { clearSelectedInterview } from '@modules/selected-interview';

const SwitchInterviewSidebarButton = () => {
    const navigate = useNavigate();

    const resetInterview = useCallback(() => {
        clearSelectedInterview();
        navigate('/select-survey');
    }, [navigate]);

    return (
        <MenuItem onClick={() => resetInterview()} icon={<RestartAltOutlinedIcon />}>
            <Typography>Switch Interview</Typography>
        </MenuItem>
    );
};

export default memo(SwitchInterviewSidebarButton);
